import { Component } from "@angular/core";
import { NavigationEnd, Router } from "@angular/router";
import { filter } from "rxjs/operators";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent {
  title = "crm";
  // showLayout = true;

  // constructor(private router: Router) {
  //   this.router.events
  //     .pipe(filter(event => event instanceof NavigationEnd))
  //     .subscribe((event: any) => {
  //       const noLayoutRoutes = ['/', '/forgot-password'];
  //       this.showLayout = !noLayoutRoutes.includes(event.urlAfterRedirects);
  //     });
  // }
}